import { refreshGenCoin } from "@/store/actions";
import { startAppListening } from "..";
import { buildTextToImageParam } from "../../buildTextToImageParam";
import { setGenCoin } from "@/reducer/modeslice";

export const addRefreshGenListener = () => {
  startAppListening({
    actionCreator: refreshGenCoin,
    effect: async (action, { getState, dispatch }) => {
      const state = getState();
      const currentGen = state.mode.currentGen;

      const getSizeMultiple = (size: number) => {
        const result = Math.ceil((size - 512 * 512) / 64 / 2048);
        return result < 0 ? 0 : result;
      };
      let coin = 1;
      if (currentGen === "TXT2IMG") {
        const params = await buildTextToImageParam(state);
        coin = coin + getSizeMultiple(params.height * params.width);
        coin = params.style === "通用" ? coin : coin + 1;
        coin = params.refStructure ? coin + 1 : coin;
        coin = params.refStyle ? coin + 1 : coin;
        coin = coin * params.n_iter;
      }
      dispatch(setGenCoin(coin));
    },
  });
};

